// src/views/BusinessClients.js
import React,{useEffect,useState} from 'react';
import {db} from '../../firebase/firebase.js';
import {collection,onSnapshot,query,orderBy} from 'firebase/firestore';
import {useAuth} from '../../auth/AuthContext.js';

const BusinessClients=()=>{
  const {user}=useAuth();
  const businessId=user?.businessId||'axuremoval'; // fallback for now

  const [clients,setClients]=useState([]);
  const [loading,setLoading]=useState(true);

  useEffect(()=>{
    if(!businessId)return;

    const q=query(
      collection(db,'businesses',businessId,'clients'),
      orderBy('createdAt','desc')
    );

    const unsub=onSnapshot(q,(snap)=>{
      const arr=[];
      snap.forEach((d)=>arr.push({...d.data(),id:d.id}));
      setClients(arr);
      setLoading(false);
    });

    return()=>unsub();
  },[businessId]);

  if(loading){
    return(
      <div className="flex justify-center items-center min-h-screen bg-neutral-950 text-white">
        <p className="opacity-60 text-lg">Loading clients...</p>
      </div>
    );
  }

  return(
    <div className="min-h-screen bg-neutral-950 text-white px-6 py-10">
      <div className="max-w-6xl mx-auto">
        
        {/* Page Title */}
        <h2 className="text-3xl font-semibold mb-8">Business Clients</h2>

        {/* Table */}
        <div className="bg-neutral-900 rounded-2xl shadow-lg p-6">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="text-neutral-400 text-sm uppercase tracking-wide border-b border-neutral-800">
                <th className="py-3">Client</th>
                <th className="py-3">Email</th>
                <th className="py-3">Phone</th>
                <th className="py-3">Service</th>
                <th className="py-3">Date</th>
              </tr>
            </thead>

            <tbody>
              {clients.length===0&&(
                <tr>
                  <td colSpan="5" className="text-center py-6 opacity-60">
                    No clients found.
                  </td>
                </tr>
              )}

              {clients.map((c)=>(
                <tr 
                  key={c.id} 
                  className="border-b border-neutral-800 hover:bg-neutral-800/40 transition"
                >
                  <td className="py-3">{c.name||'Unnamed'}</td>
                  <td className="py-3">{c.email||'-'}</td>
                  <td className="py-3">{c.phone||'-'}</td>
                  <td className="py-3">{c.serviceType||'-'}</td>
                  <td className="py-3">
                    {c.createdAt
                      ? new Date(c.createdAt).toLocaleDateString()
                      : '-'
                    }
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      </div>
    </div>
  );
};

export default BusinessClients;
